import { useLayoutEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import HerosectionHeader from "../../Componet/Herosection/HerosectionHeader";

const PricingPlans = [
    {
        title: "Uber Vehicle Inspection",
        subtitle: "Live Video Inspection",
        price: "$39.99",
        button: "Book Inspection",
        featured: true
    },
    {
        title: "Lyft Vehicle Inspection",
        subtitle: "Live Video Inspection",
        price: "$39.99",
        button: "Book Inspection",
    },
    {
        title: "Turo Vehicle Inspection",
        subtitle: "Live Video Inspection",
        price: "$39.99",
        button: "Book Inspection",
    },
    {
        title: "Pre-Purchase Inspection",
        subtitle: "Comprehensive On-Site Inspection",
        price: "$149.00",
        button: "Visit Inspectiver",
        featured: false,
        externalUrl: "https://www.inspectiver.com"
    },
];

const INCLUDED_ITEMS = [
    {
        title: "Live Video Inspection",
        description: "Complete your inspection remotely with an inspector.",
    },
    {
        title: "Guided Inspection Process",
        description: "Your inspector guides you through the required inspection points.",
    },
    {
        title: "Inspection Form",
        description: "Your completed inspection form is reviewed and sent electronically.",
    },
    {
        title: "No Shop Visit",
        description: "Complete eligible inspections from your phone without driving to an inspection location.",
    }
];

const Pricing = () => {
    const titleRefs = useRef([]);
    const subtitleRefs = useRef([]);
    const [titleHeight, setTitleHeight] = useState("auto");
    const [subtitleHeight, setSubtitleHeight] = useState("auto");

    useLayoutEffect(() => {
        const measure = () => {
            // reset first so we measure natural (unstretched) height
            setTitleHeight("auto");
            setSubtitleHeight("auto");

            requestAnimationFrame(() => {
                const tallestTitle = Math.max(
                    ...titleRefs.current.filter(Boolean).map((el) => el.offsetHeight)
                );
                const tallestSubtitle = Math.max(
                    ...subtitleRefs.current.filter(Boolean).map((el) => el.offsetHeight)
                );
                setTitleHeight(`${tallestTitle}px`);
                setSubtitleHeight(`${tallestSubtitle}px`);
            });
        };

        measure();
        window.addEventListener("resize", measure);
        return () => window.removeEventListener("resize", measure);
    }, []);

    return (<>
        <HerosectionHeader folder1={"pages"} folder2={"Utilities"} name={"Pricing"} />
        <section>
            <div className="container">
                <div className="text-center mb-5">
                    <h2 className="fw-bold">Vehicle Inspection Services</h2>
                    <p className="text-muted mb-0">
                        Online inspections for rideshare and car share drivers, plus comprehensive on-site pre-purchase inspections.
                    </p>
                </div>

                <div className="row g-4 justify-content-center">
                    {PricingPlans.map((plan, i) => (
                        <div className="col-md-6 col-lg-3" key={plan.title}>
                            <div
                                className={`card h-100 border-1 shadow-sm rounded-4 ${plan.featured ? "border border-primary border-1" : ""
                                    }`}
                            >
                                {plan.featured && (
                                    <div className="badge bg-primary position-absolute top-0 start-50 translate-middle px-3 py-2 rounded-pill">
                                        Most Popular
                                    </div>
                                )}

                                <div className="card-body p-4 p-lg-5 d-flex flex-column text-center">
                                    <h4
                                        ref={(el) => (titleRefs.current[i] = el)}
                                        className="fw-bold mb-2"
                                        style={{
                                            height: titleHeight,
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                        }}
                                    >
                                        {plan.title}
                                    </h4>

                                    <p
                                        ref={(el) => (subtitleRefs.current[i] = el)}
                                        className="text-muted mb-4"
                                        style={{
                                            height: subtitleHeight,
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                        }}
                                    >
                                        {plan.subtitle}
                                    </p>

                                    <div className="mb-4">
                                        <span className="display-5 fw-bold">{plan.price}</span>
                                    </div>
                                    <Link
                                        className="btn mt-auto py-3 rounded-3 fw-semibold btn-outline-primary"
                                        target={plan.externalUrl ? "_blank" : "_self"}
                                        to={plan.externalUrl ? plan.externalUrl : "quotation"}
                                    >
                                        {plan.button}
                                    </Link>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <div className="container pt-10 pb-5">
                <h2 className="fw-bold text-dark text-center">
                    What's Included With Your Online Inspection
                </h2>
                <div className="row border rounded g-0 mt-3">
                    {INCLUDED_ITEMS.map((item, index) => (
                        <div
                            key={item.title}
                            className={`col-6 col-md-3 text-center px-4 py-4 ${index !== INCLUDED_ITEMS.length - 1 ? "border-end" : ""
                                }`}
                        >
                            <div className="fw-bold text-dark mb-1">{item.title}</div>
                            <div className="text-secondary small">{item.description}</div>
                        </div>
                    ))}
                </div>
            </div>

            <div className="container pt-5 pb-5 text-center">
                <h2 className="fw-bold text-dark text-center">
                    Need a Different Vehicle Inspection?
                </h2>
                <p>
                    Looking for another type of vehicle inspection or not sure which service you need?
                </p>
                <Link className="btn btn-primary mt-2" aria-label="Contact Us" to="/contact">Contact Us</Link>
            </div>
        </section>
    </>)
}

export default Pricing;